export const FETCH_LOAD_PROFILES = 'FETCH_LOAD_PROFILES'
export const FETCH_LOAD_PROFILE_BY_ID = 'FETCH_LOAD_PROFILE_BY_ID'
export const FETCH_TRANSPORTER_INFO = 'FETCH_TRANSPORTER_INFO'
export const FETCH_AVAILABLE_PROPERTIES = 'FETCH_AVAILABLE_PROPERTIES'
export const FETCH_AVAILABLE_CERTIFICATES = 'FETCH_AVAILABLE_CERTIFICATES'
export const FETCH_CERTIFICATIONS_IMAGES = 'FETCH_CERTIFICATIONS_IMAGES'
export const UPDATE_CERTIFICATES_ON_STATE = 'UPDATE_CERTIFICATES_ON_STATE'
export const UPDATE_TRANSPORTER_INFO = 'UPDATE_TRANSPORTER_INFO'
export const FETCH_OPERATION_GROUPS = 'FETCH_OPERATION_GROUPS'
export const SAVE_TRANSPORTER_CONFIGS = 'SAVE_TRANSPORTER_CONFIGS'
export const LIST_ALL_CONTACTS = 'LIST_ALL_CONTACTS'
